
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Papa from 'papaparse';
import { Button, Intent, Spinner } from '@blueprintjs/core';
import { executeQueryGet, executeQueryPost } from 'app/utils/api';

interface CombinedData {
    [key: string]: string;
}

function cleanCC(entry) {
    return entry.replace("Corey", "1").replace("Oli", "4").replace("Rosa", "3").replace("Alan", "6").replace("Herman", "5").replace("Will", "2");
}

function calculateScenario(row) {
    /*
    Yes but I just added it…my number system is 90000+ for interpersonal quotes and 10000 for S1, 20000 for S2, etc.
    */

    let statement_id = parseInt(row['Statement_id']);

    if (statement_id < 20000) {
        return "1";
    }    

    if (statement_id < 30000) {
        return "2";
    }

    if (statement_id < 40000) {
        return "3";
    }

    if (statement_id < 50000) {
        return "4";
    }

    return "-1";
}

export const StatementProcessor = (props: any) => {
    const [combinedData, setCombinedData] = useState<CombinedData[]>([]);
    const [processing, setProcessing] = useState(false);
    const [uploading, setUploading] = useState(false);

    const getCleanedData = () => {
        let data = [...combinedData];
        let new_data = {
            "business": [],
            "educational": []
        };

        for (let i = 0; i < data.length; i++) {
            let row = data[i];
            let new_row = {
                "idea": row['Idea Number'],
                "scenario": calculateScenario(row),
                "statement-id": row['Statement_id'],
                "type": row['Quote Type'],
                "bucket": row['Bucket'],
                "sentiment": row['Intent'],
                "tag": row['Tag'],
                "text": row['Text'],
                "audio_file": row['filename'].toLowerCase(),
                "character": cleanCC(row['Character Number']),
                "recorded": row['Recorded'],
                "version": row["Version"]
            };

            if (row['Version'] === "Business") {
                if (row['Text'] !== "" && row['Text'] !== "NA" && row["Text"] !== undefined && row["Text"] !== null) {
                    if (row["Recorded"] === "Yes") {
                        new_data.business.push(new_row);
                    }
                }
            }
            else if (row['Version'] === "Educational") {
                if (row['Text'] !== "" && row['Text'] !== "NA" && row["Text"] !== undefined && row["Text"] !== null) {
                    if (row["Recorded"] === "Yes") {
                        new_data.educational.push(new_row);
                    }
                }
            }
            else if (row['Version'] === "Both") {
                if (row['Text'] !== "" && row['Text'] !== "NA" && row["Text"] !== undefined && row["Text"] !== null) {
                    if (row["Recorded"] === "Yes") {
                        new_data.business.push(new_row);
                        new_data.educational.push(new_row);
                    }
                }
            }
        }

        return new_data;
    }

    const onDrop = (acceptedFiles: File[]) => {
        setProcessing(true);

        const promises = acceptedFiles.map((file) =>
            new Promise<CombinedData[]>((resolve, reject) => {
                Papa.parse<CombinedData>(file, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (result) => resolve(result.data),
                    error: (error) => reject(error),
                });
            })
        );

        Promise.all(promises)
            .then((results) => {
                // Combine all rows from all files
                const allData = results.flat();
                setCombinedData(allData);
                setProcessing(false);
            })
            .catch((error) => {
                console.error('Error parsing CSV files:', error);
            });
    };

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        uploading ? <Spinner /> : <div style={{display: 'flex', flexDirection: 'column'}}>
            <Button disabled={combinedData.length === 0} intent={Intent.PRIMARY} onClick={() => {
                setUploading(true);
                executeQueryGet("/data/statement/processor/signed", {}, (tokenResponse) => {
                    const key = tokenResponse.body['key'];
                    const signed_url = tokenResponse.body['signed_url'];

                    // push JSON.stringify(getCleanedData()) to signed_url 
                    fetch(signed_url, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(getCleanedData())
                    }).then((response) => {
                        if (response.ok) {
                            executeQueryPost("data/statement/processor", {
                                key: key
                            }, (tokenResponse) => {
                                setUploading(false);
                                alert("Succesfully uploaded statements");
                            });
                        }
                    });

                    /*
                    executeQueryPost("data/statement/processor", {
                        statements: JSON.stringify(getCleanedData())
                    }, (tokenResponse) => {
                        setUploading(false);
                        alert("Succesfully uploaded statements");
                    });*/
                });


            }}>Upload Statements</Button>

            <div style={{ padding: '20px', border: '2px dashed #aaa', textAlign: 'center' }}>
                <div {...getRootProps()} style={{ padding: '20px', cursor: 'pointer' }}>
                    <input {...getInputProps()} />
                    {processing ? <Spinner /> : <p>Drag and drop CSV files here, or click to select files</p>}
                </div>
                {combinedData.length > 0 && (
                    <div style={{ marginTop: '20px' }}>
                        <h3>Combined Data</h3>
                        <table cellPadding="5" style={{ width: '100%', textAlign: 'left' }}>
                            <thead>
                                <tr>
                                    {Object.keys(combinedData[0]).map((key) => (
                                        <th key={key}>{key}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {combinedData.map((row, index) => (
                                    <tr key={index}>
                                        {Object.values(row).map((value, i) => (
                                            <td key={i}>{value}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
